export const BRAND_ID = 'B61A4A08-1914-49CD-B86E-60D5D00575F9';

